import { lazy, Suspense, useEffect, useRef, useState } from "react";

const ServiceGlobe = lazy(() => import("../ServiceGlobe"));

/** 滚到可视区域附近再加载 Three.js 地球，避免拖慢首屏 */
function DeferredServiceGlobe() {
  const hostRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const node = hostRef.current;
    if (!node || shouldLoad) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      setShouldLoad(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px 0px" }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [shouldLoad]);

  return (
    <div ref={hostRef} className="service-globe-defer-host">
      {shouldLoad ? (
        <Suspense fallback={<div className="service-globe-placeholder" aria-hidden="true" />}>
          <ServiceGlobe />
        </Suspense>
      ) : (
        <div className="service-globe-placeholder" aria-hidden="true" />
      )}
    </div>
  );
}

export default DeferredServiceGlobe;
